/* ==========================================================================
   VeteNa · "Ver X colores más" en el selector de color de la PDP
   Trabaja SOBRE el selector nativo de Dawn. No toca variantes, precio,
   inventario ni el formulario. Si se borra el archivo, todo sigue funcionando.
   Archivo: assets/vetena-swatches.js
   ========================================================================== */

(function () {
  'use strict';

  // Cuántos colores se ven antes de plegar el resto.
  var LIMIT = window.VETENA_SWATCH_LIMIT || 12;

  var FIELDSET = '.product-form__input--swatch';

  function label(count, expanded) {
    return expanded ? 'Ver menos colores' : 'Ver ' + count + ' colores más';
  }

  function setup(fieldset) {
    if (fieldset.dataset.vtSwatchReady === 'true') return;
    fieldset.dataset.vtSwatchReady = 'true';

    var labels = fieldset.querySelectorAll('.swatch-input__label');
    var inputs = fieldset.querySelectorAll('.swatch-input__input');
    if (labels.length <= LIMIT) return;

    var hidden = labels.length - LIMIT;
    var checkedIndex = -1;
    var i;

    for (i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) checkedIndex = i;
    }

    for (i = LIMIT; i < labels.length; i++) {
      labels[i].classList.add('vt-swatch-extra');
    }

    // Si el color ya seleccionado estaba entre los ocultos, se abre de inicio.
    var expanded = checkedIndex >= LIMIT;
    fieldset.classList.toggle('vt-swatches-collapsed', !expanded);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vt-more-colors';
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = label(hidden, expanded);

    button.addEventListener('click', function () {
      expanded = !expanded;
      fieldset.classList.toggle('vt-swatches-collapsed', !expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = label(hidden, expanded);
      if (expanded && inputs[LIMIT]) inputs[LIMIT].focus();
    });

    fieldset.appendChild(button);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll(FIELDSET);
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  init();
  document.addEventListener('DOMContentLoaded', function () { init(); });

  // Dawn recarga la sección al cambiar de variante y en el editor de temas.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      init();
    });
  });

  var target = document.getElementById('MainContent') || document.body;
  if (target) observer.observe(target, { childList: true, subtree: true });
})();
